// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1iam7","image":"Header_image__3BF79","name":"Header_name__2rI7r","info":"Header_info__3LK1q","infoRow":"Header_infoRow__1lY68"};